<!-- HTML -->
<template>
  <div class="flex flex-col h-full overflow-hidden">
    <header>
      <div class="border-b border-slate-300">
        <p class="font-semibold text-base pt-4 pb-3 px-3">
          Discussion Questions
        </p>
      </div>
    </header>
    <main
      class="flex-col overflow-y-auto px-3"
      :class="isFullscreen ? 'height-list-fullscreen' : 'height-list'"
    >
      <div class="bg-white text-lg">
        <div v-if="visible_guidances.length">
          <div
            v-for="(question, index) in toggleable_guiding_questions"
            :key="index + 1"
            v-if="question.is_active"
            class="mt-2 p-2"
          >
            {{ index + 1 }}. {{ question.question }}
          </div>
        </div>
        <div v-else>
          <div class="mt-2 p-2">No Guiding Questions created or activated</div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {};
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion']),
      toggleable_guiding_questions() {
        return this.getCurrentDiscussion.toggleable_guiding_questions;
      },
      visible_guidances() {
        return this.getCurrentDiscussion.toggleable_guiding_questions.filter(
          (guidance) => {
            return guidance.is_active;
          }
        );
      },
    },
    props: {
      isFullscreen: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style scoped>
  .height-list {
    height: calc(100vh - 236px);
    overflow-y: auto;
  }
  .height-list-fullscreen {
    height: calc(100vh - 80px);
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// discussionQuestionsSecondScreen.vue?7c0e79e0